import { Dialog, DialogContent } from '@cmp-src/primitives/Dialog';
import { Button } from '@v2/components/ui/button';
import { Trash } from 'lucide-react';

interface DeleteRequestConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  requestTitle: string;
}

export function DeleteRequestConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  requestTitle
}: DeleteRequestConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="z-popover max-w-md">
        <div className="p-6">
          <div className="mb-4 flex items-center space-x-3">
            <div className="flex-shrink-0">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
                <Trash className="h-5 w-5 text-red-600" />
              </div>
            </div>
            <div>
              <h3 className="font-medium text-gray-900 text-lg">
                Delete Request
              </h3>
              <p className="text-gray-500 text-sm">
                This action cannot be undone
              </p>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-gray-700 text-sm">
              Are you sure you want to delete "{requestTitle}"? This action
              cannot be undone.
            </p>
          </div>

          <div className="flex justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              className="bg-red-600 text-white hover:bg-red-700"
            >
              Delete
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
